import { HealthArticle } from '../../../../services/performanceMetricsService';

export const fmt = (n: number | null | undefined): string => {
  if (n == null) return '\u2014';
  if (n >= 10000) return `${(n / 1000).toFixed(0)}k`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
};

export const fmtPos = (n: number | null | undefined): string => {
  if (n == null) return '\u2014';
  return n.toFixed(1);
};

export const fmtDate = (iso: string | null | undefined): string => {
  if (!iso) return '\u2014';
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '\u2014';
  }
};

export const decodeHtml = (s: string): string =>
  s.replace(/&#038;/g, '&').replace(/&amp;/g, '&').replace(/&#8217;/g, '\u2019')
    .replace(/&#8216;/g, '\u2018').replace(/&quot;/g, '"').replace(/&hellip;/g, '\u2026')
    .replace(/&#8211;/g, '\u2013').replace(/&#8212;/g, '\u2014')
    .replace(/&lt;/g, '<').replace(/&gt;/g, '>');

export const isClicksDeclining = (article: HealthArticle): boolean => {
  const check = article.checks.find((c) => c.check_id === 'clicks_declining');
  return check != null && check.severity > 0;
};

export const severityColor = (severity: number): string => {
  if (severity >= 8) return 'text-red-600';
  if (severity >= 5) return 'text-amber-600';
  if (severity >= 1) return 'text-yellow-600';
  return 'text-gray-400';
};

export const severityBg = (severity: number): string => {
  if (severity >= 8) return 'bg-red-50 border-red-200';
  if (severity >= 5) return 'bg-amber-50 border-amber-200';
  if (severity >= 1) return 'bg-yellow-50 border-yellow-200';
  return 'bg-gray-50 border-gray-200';
};
